'use es6';

import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useReducer } from 'react';
var INITIAL_FRAME_DIMENSIONS = {
  height: '500px',
  width: '900px'
};
export var FRAME_ACTIONS = {
  LOAD_FRAME: 'LOAD_FRAME',
  FRAME_READY: 'FRAME_READY',
  CLOSE_FRAME: 'CLOSE_FRAME',
  HIDE_PARENT_MODAL: 'HIDE_PARENT_MODAL',
  RESIZE_PARENT_MODAL: 'RESIZE_PARENT_MODAL'
};
var initialFrameState = {
  loadFrame: false,
  frameReady: false,
  showParentModal: true,
  frameDimensions: INITIAL_FRAME_DIMENSIONS
};

var frameReducer = function frameReducer(state, action) {
  var LOAD_FRAME = FRAME_ACTIONS.LOAD_FRAME,
      FRAME_READY = FRAME_ACTIONS.FRAME_READY,
      CLOSE_FRAME = FRAME_ACTIONS.CLOSE_FRAME,
      HIDE_PARENT_MODAL = FRAME_ACTIONS.HIDE_PARENT_MODAL,
      RESIZE_PARENT_MODAL = FRAME_ACTIONS.RESIZE_PARENT_MODAL;

  switch (action.type) {
    case LOAD_FRAME:
      return Object.assign({}, state, {
        loadFrame: true
      });

    case FRAME_READY:
      return Object.assign({}, state, {
        frameReady: true
      });

    case HIDE_PARENT_MODAL:
      return Object.assign({}, state, {
        showParentModal: false
      });

    case RESIZE_PARENT_MODAL:
      return Object.assign({}, state, {
        showParentModal: true,
        frameDimensions: Object.assign({}, state.frameDimensions, {}, action.payload)
      });

    case CLOSE_FRAME:
      return initialFrameState;

    default:
      return state;
  }
};

export var useModalFrameReducer = function useModalFrameReducer() {
  var _useReducer = useReducer(frameReducer, initialFrameState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      frameState = _useReducer2[0],
      dispatchFrameAction = _useReducer2[1];

  return [frameState, dispatchFrameAction];
};